import { useMemo } from "react";
import { useOutletContext, useParams } from "react-router-dom";
import DynamicContentPage from "./DynamicContentPage";
import { useContentContext } from "../../../app/providers/contextIndex";
import NotFound from "../../../shared/pages/NotFound"


const DynamicContent = () => {
  const { slug = "" } = useParams();
  const { activeLandingId} = useOutletContext() || {};
  const { getPageBySlug } = useContentContext();

  const hasContentPage = useMemo(
    () => !!getPageBySlug(activeLandingId, slug),
    [activeLandingId, getPageBySlug, slug]
  );

  if (hasContentPage) return <DynamicContentPage />;

  return <NotFound />;
};

export default DynamicContent;